<template>
    <div>
        <span v-if="trendChanged" class="cursor-pointer border-b border-dashed border-gray-500 font-bold" :class="directionClass[0]" v-tooltip="tooltipOptions">
            {{ currentDirection }}
        </span>
        <span v-else :class="directionClass[0]">
            {{ currentDirection }}
        </span>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const trendType = computed(() => {
    if (props.formatted.dailyTrendSpotterDirection) return 'daily';
    if (props.formatted.weeklyTrendSpotterDirection) return 'weekly';
    if (props.formatted.monthlyTrendSpotterDirection) return 'monthly';
    return 'intraday';
});

const signal = (current = true) => {
    if (trendType.value === 'intraday') {
        return current ? props.formatted.trendSpotterSignal : props.formatted.trendSpotterSignalPrevious;
    }
    return current ? props.formatted[trendType.value + 'TrendSpotterSignal'] : props.formatted[trendType.value + 'TrendSpotterSignalPrevious'];
};

const currentDirection = computed(() => {
    if (trendType.value === 'intraday') {
        return props.formatted.trendSpotterDirection;
    }
    return props.formatted[trendType.value + 'TrendSpotterDirection'];
});

const previousDirection = computed(() => {
    if (trendType.value === 'intraday') {
        return props.formatted.trendSpotterDirectionPrevious;
    }
    return props.formatted[trendType.value + 'TrendSpotterDirectionPrevious'];
});

const trendChanged = computed(() => currentDirection.value !== previousDirection.value || signal() !== signal(false));

const directionClass = computed(() => {
    if (signal() === 'Down') return ['text-down', 'fa-caret-down'];
    if (signal() === 'Up') return ['text-up', 'fa-caret-up'];
    return ['text-unch', 'fa-minus'];
});

const tooltipOptions = computed(() => ({
    content: getTooltip(),
    theme: 'light',
    placement: 'auto-start',
}));

const getTooltip = () => `
    <div style="min-width:8rem;">
        <div class="font-bold mb-3">${props.formatted.symbolName}<i class="fas text-lg ml-2 ${directionClass.value[0]} ${directionClass.value[1]}"></i></div>
        <div class="text-xs font-bold text-gray-500 mb-1">PREVIOUSLY</div>
        <div class="mb-1"><span class="mr-2">Trend:</span><span class="float-right ${directionClass.value[0]}">${signal(false)}</span></div>
        <div><span class="mr-2">Rank:</span><span class="float-right ${directionClass.value[0]}">${previousDirection.value}</span></div>
    </div>
`;
</script>
